module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('drag', {
    staticClass: "drag",
    attrs: {
      "transfer-data": _vm.scopedData
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [(props.transferData) ? _c('div', [_vm._v("\n\t\t\t\t" + _vm._s(props.transferData.dragText) + "\n\t\t\t")]) : _c('div', [_vm._v("drag me")])]
      }
    }])
  }), _vm._v(" "), _c('drop', {
    staticClass: "drop",
    on: {
      "drop": _vm.handleDrop
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [(props.transferData) ? _c('div', {
          staticClass: "drag"
        }, [_vm._v("\n\t\t\t\t" + _vm._s(props.transferData.dropText) + "\n\t\t\t")]) : _vm._e()]
      }
    }])
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ed212908","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Scoped.vue
// module id = 54
// module chunks = 0